import React, { Component } from "react";
import { UncontrolledAlert, Button } from "reactstrap";
import { withFormsy } from "formsy-react";
import { MySelect } from "../../Shared/Forms";
import { Spinner } from "../../Shared";
import { foodLibraryService } from "./services/FoodLibrary.service";

class MeasureDropDown extends Component {
    state = {
        fetching: false,
        fetched: false,
        response: null,
        error: null,
        pageNum: 0,
        pageSize: 1000,
    };

    componentDidMount() {
          
        const { pageNum, pageSize } = this.state;
        this.getAllFoodMetric({ "page-num": pageNum + 1, "page-size": pageSize });
    }
    getAllFoodMetric = (params) => {
        this.setState({ fetching: true });
        foodLibraryService
            .getAllFoodMeasureServices(params)
            .then((response) => {
               
                response &&
                    this.setState({
                        response: response,
                        pages: Math.ceil(response.count / params["page-size"]),
                        error: null,
                        fetching: false,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };

    render() {
        const { name, value, disabled, isMulti, title, isRequired, isClearable } = this.props;

        const { fetching, response, error, pageNum, pageSize } = this.state;

        return (
            <div>
                {fetching ? (
                    <UncontrolledAlert color="info">
                        <Spinner message="Fetching metric unit" />
                    </UncontrolledAlert>
                ) : (
                    <div>
                        <MySelect
                            isMulti={isMulti}
                            name={name}
                            isClearable={isClearable}
                            title={title}
                            options={response ? response.data : []}
                            value={value}
                            valueKey="id"
                            disabled={disabled}
                            labelKey="name"
                            innerRef={(c) => {
                                this.metrics = c;
                            }}
                            required={isRequired}
                        />
                        {!response && error && (
                            <UncontrolledAlert color="danger">
                                {error.message}
                                <div className="float-reight"><Button color="danger" onClick={this.getAllFoodMetric({ "page-num": pageNum + 1, "page-size": pageSize })}>
                                        Retry
                                    </Button></div>
                            </UncontrolledAlert>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default withFormsy(MeasureDropDown);
